import { ref } from "vue";
import { DialogueModal as DialogueModalOptions } from "@/models/modal";

export default function useCustomDialogueModal() {
  const showDialogueModal = ref<boolean>(false);

  const dialogueModalOptions = ref<DialogueModalOptions>({
    title: undefined,
    description: undefined,
    buttons: [],
    loading: false,
  });

  function openDialogueModal(options: DialogueModalOptions) {
    dialogueModalOptions.value = {
      ...options,
    };

    showDialogueModal.value = true;
  }

  function closeDialogueModal() {
    showDialogueModal.value = false;

    resetDialogueModal();
  }

  function resetDialogueModal() {
    dialogueModalOptions.value = {
      title: undefined,
      description: undefined,
      buttons: [],
      loading: false,
      closeBtn: false,
    };
  }

  function setDialogueModalLoadingState(flag: boolean) {
    dialogueModalOptions.value.loading = flag;
  }

  return {
    closeDialogueModal,
    dialogueModalOptions,
    openDialogueModal,
    resetDialogueModal,
    setDialogueModalLoadingState,
    showDialogueModal,
  };
}
